import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, Fragment} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { Menu_Food_CreateInventoryItemModal } from './Modal_EnterMenuItem_Food';
import { Menu_Drink_CreateInventoryItemModal } from './Modal_EnterMenuItem_Drinks';
import { Cart } from './Cart';


export function MenuItem_Add (props){

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showCreateMenuFoodModal, setShowCreateMenuFoodModal] = useState(false);
    let [showCreateMenuDrinksModal, setShowCreateMenuDrinksModal] = useState(false);

    let [showQuantityButton_Food, setShowQuantityButton_Food] = useState(false);
    let [showQuantityButton_Drink, setShowQuantityButton_Drink] = useState(false);

    let [viewInventoryItemMainDetailsData_Food, setViewInventoryItemMainDetailsData_Food] = useState([]);
    let [viewInventoryItemMainDetailsData_Drink, setViewInventoryItemMainDetailsData_Drink] = useState([]);

    let [itemID, setItemID] = useState(null);

    const [cartModal, setCartModal] = useState(false);

    function onSubmitNewDateHandler(e)
    {

        /*let formData = new FormData();
        formData.append('Tracker', '74112_U_OUT');
        formData.append('user', acctID);



        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74112_U_OUT',
                user: acctID,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let rows = data.toString().split('~~~');
    
            
        })
        .catch(error => {
            console.error(error);
        })

    }

    function getDataItemMain(event) {

        let category = event;
            
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: category,
                user: acctID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
    
            let rows = res.toString().split('~~~');
    
            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

    
                if(category == "74401_R_Food")
                {
                    setViewInventoryItemMainDetailsData_Food((prevViewInventoryItemMainDetailsData) => {
                        return prevViewInventoryItemMainDetailsData.concat({
                            itemID: cols[0],
                            itemName: cols[1],
                            vendorPartNum: cols[2],
                            vendorName: cols[3],
                            costPerUnit: parseFloat(cols[4]).toFixed(2),
                            qtyInStock: cols[5],
                            dateReplenished: cols[6],
                            addedBy: cols[7],
                        })
                    });
                }
                else if(category == "74401_R_Drink")
                {
                    setViewInventoryItemMainDetailsData_Drink((prevViewInventoryItemMainDetailsData) => {
                        return prevViewInventoryItemMainDetailsData.concat({
                            itemID: cols[0],
                            itemName: cols[1],
                            vendorPartNum: cols[2],
                            vendorName: cols[3],
                            costPerUnit: parseFloat(cols[4]).toFixed(2),
                            qtyInStock: cols[5],
                            dateReplenished: cols[6],
                            addedBy: cols[7],
                        })
                    });
                }
    
            } 
        })
    }

    function increaseQuantity()
    {
        document.getElementById("setQuantity").stepUp();
    }
    function decreaseQuantity()
    {
        document.getElementById("setQuantity").stepDown();
    }

    function addMenuItem_ToInvoice(event)
    {

        alert('Inside Add Menu Item');
    
        let formData = new FormData();
        let Tracker = '';

        //let totalRooms = [...checkInRoomID_multiple, checkInRoomID];
    

            //formData.append('Tracker', 74706);
            //formData.append('user', acctID);            

            if(event[4] = "Food_Main")
            {
                formData.append('Tracker', '74402_R_Food');
                Tracker = '74402_R_Food';
            }
            else if(event[4] = "Drink")
            {
                formData.append('Tracker', '74402_R_Drink');
                Tracker = '74402_R_Drink';

            }
            /*formData.append('user', acctID);
            formData.append('xInvoiceID', props.data.invoiceID);
            formData.append('xCheckInRoomID', props.data.roomID);
            formData.append('xQuanityToAdd', document.getElementById('setQuantity').value);
            formData.append('menu_xInventoryItemName', event[1]);
            formData.append('menu_xInventoryItemCostPerUnit', event[2]);
            formData.append('xExtendedSalePrice', (event[2]*document.getElementById('setQuantity').value));
            formData.append('menu_xInventoryVendorName', event[3]);
            formData.append('xCustomerInvoiceID', props.data.customerInvoiceID);
            formData.append('menu_xInventoryItemID', event[0]);


            const requestOptions = {
                encType: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }*/

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                //body: JSON.stringify({formData})
                body: JSON.stringify({
                    Tracker: Tracker,
                    user: acctID,
                    xInvoiceID: props.data.invoiceID,
                    xCheckInRoomID: props.data.roomID,
                    xQuanityToAdd: document.getElementById('setQuantity').value,
                    menu_xInventoryItemName:  event[1],
                    menu_xInventoryItemCostPerUnit:  event[2],
                    xExtendedSalePrice: (event[2]*document.getElementById('setQuantity').value),
                    menu_xInventoryVendorName: event[3],
                    xCustomerInvoiceID: props.data.customerInvoiceID,
                    menu_xInventoryItemID: event[0],
                    sessionID: sessionID,

                })
            }
        
            alert('addMenuItem_ToInvoice Before Fetch');
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                alert(res);
        
                props.closeModal();
        
            })

    }

    function quantityButton_Food(event) {

        setItemID(event[0]);
        setShowQuantityButton_Food(event[1]);

    }

    function quantityButton_Drink(event) {

        setItemID(event[0]);
        setShowQuantityButton_Drink(event[1]);

    }

    useEffect(() =>  {
        
        getDataItemMain("74401_R_Food");
        getDataItemMain("74401_R_Drink");   
   

    }, [])
    

        return (
            <Fragment>
                <IonGrid >
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => setCartModal(true)}>
                                <span>
                                    <IonIcon name='cart'></IonIcon>
                                </span>
                                <span>Your Cart</span>
                                <span>
                                    3
                                </span>
                            </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <h3>MENU</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton > Food </IonButton>
                        </IonCol>
                        {authenticatedMerchent_context.accessRights[0] == 'admin' && 
                        <IonCol>
                            <IonButton onClick={() => setShowCreateMenuFoodModal(true)}> Add Food item </IonButton>
                        </IonCol>}
                    </IonRow>
                        <div id='inventoryItemOverviewGrid' style={{display: 'inline-block'}}>
                                <IonText> Hotel Items </IonText>

                                <IonGrid class='gridText'>
                                        <IonRow >
                                                <IonCol >Item ID</IonCol>
                                                <IonCol >Item Name</IonCol>
                                                {/*<IonCol >Vendor Part Number</IonCol>*/}
                                                {/*<IonCol >Vendor Name</IonCol>*/}
                                                <IonCol >Cost per Unit</IonCol>
                                                <IonCol >Qty InStock</IonCol>
                                                {/*<IonCol >Date Replenished</IonCol>*/}
                                                {/*<IonCol >Added By</IonCol>*/}
                                                <IonCol >Action</IonCol>
                                        </IonRow>
                                        {viewInventoryItemMainDetailsData_Food.map((detailData) =>   {
                                            return (
                                                <IonRow key={detailData.itemID}>
                                                    <IonCol >{detailData.itemID}</IonCol>
                                                    <IonCol >{detailData.itemName}</IonCol>
                                                    {/*<IonCol >{detailData.vendorPartNum}</IonCol>*/}
                                                    {/*<IonCol >{detailData.vendorName}</IonCol>*/}
                                                    <IonCol >{detailData.costPerUnit}</IonCol>
                                                    <IonCol >{detailData.qtyInStock}</IonCol>
                                                    {/*<IonCol >{detailData.dateReplenished}</IonCol>*/}
                                                    {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                                    <IonCol >
                                                        <IonButton  > Cancel </IonButton>
                                                        {showQuantityButton_Food == false  && <IonButton  onClick={() => quantityButton_Food([detailData.itemID, true])} > Add </IonButton>}
                                                        {showQuantityButton_Food == true && itemID == detailData.itemID  && <input type='number' id='setQuantity' value='1' min='1'></input>}
                                                        {showQuantityButton_Food == true && itemID == detailData.itemID  && <IonButton onClick={() => increaseQuantity(true)}>+</IonButton>}
                                                        {showQuantityButton_Food == true && itemID == detailData.itemID  && <IonButton onClick={() => decreaseQuantity(true)}>-</IonButton>}
                                                        {showQuantityButton_Food == true && itemID == detailData.itemID  && <IonButton  > Add to Cart </IonButton>}
                                                        {showQuantityButton_Food == true && itemID == detailData.itemID  && <IonButton  onClick={() => addMenuItem_ToInvoice([detailData.itemID, detailData.itemName, detailData.costPerUnit, detailData.vendorName, "Food_Main"])}> Add to Invoice </IonButton>}
                                                    </IonCol>
                                                </IonRow>
                                            )
                                        }
                                        )}
                                </IonGrid>
                        </div>
                    <IonRow>
                        <IonCol >
                            <IonButton > Drinks </IonButton>
                        </IonCol>
                        {authenticatedMerchent_context.accessRights[0] == 'admin' && 
                        <IonCol>
                            <IonButton onClick={() => setShowCreateMenuDrinksModal(true)}> Add Drink Item </IonButton>
                        </IonCol>}
                    </IonRow>
                        <div id='inventoryItemOverviewGrid_Drink' style={{display: 'inline-block'}}>
                                <IonText> Hotel Items </IonText>

                                <IonGrid class='gridText'>
                                        <IonRow >
                                                <IonCol >Item ID</IonCol>
                                                <IonCol >Item Name</IonCol>
                                                {/*<IonCol >Vendor Part Number</IonCol>*/}
                                                {/*<IonCol >Vendor Name</IonCol>*/}
                                                <IonCol >Cost per Unit</IonCol>
                                                <IonCol >Qty InStock</IonCol>
                                                {/*<IonCol >Date Replenished</IonCol>*/}
                                                {/*<IonCol >Added By</IonCol>*/}
                                                <IonCol >Action</IonCol>
                                        </IonRow>
                                        {viewInventoryItemMainDetailsData_Drink.map((detailData) =>   {
                                            return (
                                                <IonRow >
                                                    <IonCol >{detailData.itemID}</IonCol>
                                                    <IonCol >{detailData.itemName}</IonCol>
                                                    {/*<IonCol >{detailData.vendorPartNum}</IonCol>*/}
                                                    {/*<IonCol >{detailData.vendorName}</IonCol>*/}
                                                    <IonCol >{detailData.costPerUnit}</IonCol>
                                                    <IonCol >{detailData.qtyInStock}</IonCol>
                                                    {/*<IonCol >{detailData.dateReplenished}</IonCol>*/}
                                                    {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                                    <IonCol >
                                                        <IonButton  > Cancel </IonButton>
                                                        {showQuantityButton_Drink == false  && <IonButton  onClick={() => quantityButton_Drink([detailData.itemID, true])} > Add </IonButton>}
                                                        {showQuantityButton_Drink == true && itemID == detailData.itemID && <input type='number' id='setQuantity' value='1' min='1'></input>}
                                                        {showQuantityButton_Drink == true && itemID == detailData.itemID && <IonButton onClick={() => increaseQuantity(true)}>+</IonButton>}
                                                        {showQuantityButton_Drink == true && itemID == detailData.itemID && <IonButton onClick={() => decreaseQuantity(true)}>-</IonButton>}
                                                        {showQuantityButton_Drink == true && itemID == detailData.itemID && <IonButton  > Add to Cart </IonButton>}
                                                        {showQuantityButton_Drink == true && itemID == detailData.itemID && <IonButton  onClick={() => addMenuItem_ToInvoice([detailData.itemID, detailData.itemName, detailData.costPerUnit, detailData.vendorName, "Drink"])}> Add to Invoice </IonButton>}
                                                    </IonCol>
                                                </IonRow>
                                            )
                                        }
                                        )}
                                </IonGrid>
                        </div>
                </IonGrid>

                {showCreateMenuFoodModal == true && <Menu_Food_CreateInventoryItemModal openModal={ showCreateMenuFoodModal } closeModal={() => setShowCreateMenuFoodModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></Menu_Food_CreateInventoryItemModal>}
                {showCreateMenuDrinksModal == true && <Menu_Drink_CreateInventoryItemModal openModal={ showCreateMenuDrinksModal } closeModal={() => setShowCreateMenuDrinksModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></Menu_Drink_CreateInventoryItemModal>}

                {cartModal && <Cart></Cart>}
            </Fragment>
        )
}